import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class TicketActionService {
    readonly actionButtons = signal<{ label: string; action: () => void; variant?: 'solid' | 'outline' }[]>([]);

    setButtons(buttons: { label: string; action: () => void; variant?: 'solid' | 'outline' }[]) {
        this.actionButtons.set(buttons);
    }

    clearButtons() {
        this.actionButtons.set([]);
    }
}
